import { IVisibility, VisibilityRuleComparator } from './types';

const supportedRuleTypes: string[] = ['date', 'time', 'weekDay'];

export const formatVisibility = (visibility?: IVisibility): IVisibility => {
  if (!visibility || !visibility.rules || !visibility.rules.length) {
    return { ...visibility, state: 'visible' };
  }

  const rules = visibility.rules
    .filter(rule => rule.type && supportedRuleTypes.includes(rule.type))
    .map(
      (rule, index) =>
        index
          ? { ...rule, logic: 'and' }
          : { type: rule.type, comparator: rule.comparator, value: rule.value }
    );

  return {
    ...visibility,
    state: 'conditional',
    rules,
  };
};

export const getVisibilityDates = (visibility: IVisibility) => {
  if (visibility.rules == undefined) {
    return {};
  }

  const startDate = visibility.rules.find(
    rule =>
      rule.type === 'date' && rule.comparator === VisibilityRuleComparator.FROM
  );
  const endDate = visibility.rules.find(
    rule =>
      rule.type === 'date' && rule.comparator === VisibilityRuleComparator.TO
  );

  return {
    startDate: startDate ? startDate.value : '',
    endDate: endDate ? endDate.value : '',
  };
};
